import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from './auth.service';

@Component({
  standalone: true,
  template: `<p>Logging in...</p>`
})
export class AuthCallbackComponent {
  private auth = inject(AuthService);
  private oauth = inject(OAuthService);
  private router = inject(Router);

  constructor() {
    console.log('AuthCallbackComponent initialized');
    this.auth.init().then(() => {
      this.oauth.loadDiscoveryDocumentAndTryLogin().then(() => {
        if (this.oauth.hasValidAccessToken()) {
          this.router.navigate(['/dashboard'], { replaceUrl: true });
        } else {
          this.router.navigate(['/login'], { replaceUrl: true });
        }
      }).catch(() => {
        this.router.navigate(['/login'], { replaceUrl: true });
      });
    }).catch(() => {
      this.router.navigate(['/login'], { replaceUrl: true });
    });
  }
}